<template>
  <div id="notaricationPayment">
    <WeixinQRCodePay
      ref="weixinQRCodePay"
      @paymentComplete="wxPaymentComplete"
      :isVisible.sync="weixinPay.isVisible"
    >
      <!-- <template slot="info">
        <div class="weixinQRCodePayTitle">
          <div class="weixinQRCodePayTitle_left">{{templateInfo.desc}}易比得订单号：{{sysOrderNumber}}</div>
          <div class="weixinQRCodePayTitle_right">应付金额
            <span class="weixinQRCodePayTitle_right_price">{{templateInfo.price}}</span>元</div>
        </div>
      </template> -->
    </WeixinQRCodePay>
  </div>
</template>
<script>
import WeixinQRCodePay from '@/components/weixin/pay/WeixinQRCodePay';
import eventBus from '@/plugins/event-bus';
export default {
  name: 'notaricationPayment',
  components: {
    WeixinQRCodePay
  },
  data() {
    return {
      templateInfo: {
        desc: '',
        price: null
      },
      weixinPay: {
        isVisible: false
      },
      sysOrderNumber: null,
      notarization: {},
      refreshUrl: '',
      payInfo: {
        orderType: 'HGJZ1808',
        departId: this.$store.state.user.userInfo.departId,
        content: '易比得合规采购云合规鉴证申请',
        amount: null,
        departName: this.$store.state.user.userInfo.departName
      }
    };
  },
  created() {
    eventBus.$off('initNotarizationPaymentData');
    eventBus.$on('initNotarizationPaymentData', params => {
      this.refreshUrl = params.refreshUrl;
      this.notarization = params.notarization;
      this.initData();
    });
  },
  methods: {
    async initData() {
      this.weixinPay.isVisible = true;
      this.templateInfo.desc =
        '您正在进行' +
        this.notarization.projectName +
        '项目鉴证费用支付，项目编号 ' +
        this.notarization.projectCode;
      this.templateInfo.price = this.notarization.sumMoney;
      this.payInfo.amount = this.notarization.sumMoney;
      // await this.initOrderNo();
      // 初始化微信支付二维码
      eventBus.$emit('initWeixinPayQRCode', {
        productId: this.payInfo.orderType,
        outTradeNo: this.sysOrderNumber,
        body: this.payInfo.content,
        price: this.templateInfo.price,
        desc: this.templateInfo.desc,
        orderParams: {
          orderType: this.payInfo.orderType,
          buyerOrgId: this.payInfo.departId,
          orderAmount: this.payInfo.amount,
          notarization: JSON.stringify(this.notarization)
        }
      });
    },
    // 微信支付完成
    wxPaymentComplete(weixinPayInfo) {
      if (weixinPayInfo.status === 'SUCCESS') {
        this.weixinPay.isVisible = false;
        this.$message.success('微信支付成功');
        if (this.refreshUrl === '/projpro/quoted/list' || this.refreshUrl === '/projbid/quoted/list') {
          location.reload();
        } else {
          this.$router.push(this.refreshUrl);
        }
      } else {
        this.$message.error('微信支付失败');
      }
    }
  },
  beforeDestroy() {}
};
</script>
